import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser, CheckPermission } from "../../../components/widget"
import { ContextNav, ContextRollCall, ContextLoading, ContextDashboard } from "../../../context";
import { Link } from "react-router-dom";
import { RollCallApi, DeleteRollCallApi, RollCallExport, RollCallFullExport } from "../../../api";
import { convertDateToString, converDurationToMin, convertStringDateToDateSupport } from "../../../utils";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

export const Rollcall = () => {
    const CtxNav = useContext(ContextNav)
    const CtxRoll = useContext(ContextRollCall)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleUser, setVisibleUser] = useState<boolean>(false)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [total, setTotal] = useState<any>(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [tableData, setTableData] = useState<any>([])
    const [col, setCol] = useState<any>([
        {
            title: "کارمند ",
            render: (i: any) => (
                <div className="flex items-center h-[70px]">
                    {/* <svg x="0px" y="0px" viewBox="0 0 512 512" className={`  w-[40px] fill-dayan-orange-50 `}>
                        <use xlinkHref="/assetes/svg/person.svg#person" />
                    </svg> */}
                    {i.user?.profile?.avatar &&
                        <img src={i.user?.profile.avatar} className="w-[50px] h-[50px] rounded-full ml-2" />
                    }
                    <span className="mr-2">{i.user && i.user != null && i.user.name}</span>
                </div>)
        },
        {
            title: "موقعیت مکانی ",
            render: (i: any) => (<>{i.qr_code_id && i.qr_code_id != null && findLocation(i.qr_code_id)}</>)
        },
        {
            title: "تاریخ ",
            render: (i: any) => (
                <>
                    <>{i.entrance && i.entrance != null && new Date(i.entrance).toLocaleDateString('fa-Ir')}</>
                    <>{!i.entrance && i.entrance == null && i.exit && i.exit != null && new Date(i.exit).toLocaleDateString('fa-Ir')}</>
                </>
            )
        },
        {
            title: "ورود ",
            render: (i: any) => (
                <div className="flex flex-col">
                    <span>{i.entrance && i.entrance != null && i.entrance.slice(11, 16)}</span>
                    <span className="mt-1">{i.entrance_qr_code_id && i.entrance_qr_code_id != null && findLocation(i.entrance_qr_code_id)}</span>
                </div>
            )
        },
        {
            title: "خروج ",
            render: (i: any) => (
                <div className="flex flex-col">
                    <span>{i.exit && i.exit != null && i.exit.slice(11, 16)}</span>
                    <span className="mt-1">{i.exit_qr_code_id && i.exit_qr_code_id != null && findLocation(i.exit_qr_code_id)}</span>
                </div>
            )
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-around ">
                    {CheckPermission(5) &&
                        <Link to={`/p/reports/rollcall/${i.id}`}>
                            <img src="/assetes/svg/edit.svg" className="w-[20px] cursor-pointer" />
                        </Link>
                    }
                    {CheckPermission(6) &&
                        <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] cursor-pointer" />
                    }
                </div>)
        },
    ])

    const findLocation = (id: number) => {
        let data = [...CtxDash.location]
        for (let i of data) {
            if (i.id == id) {
                return i.name
            }
        }
    }

    const renderOvertimes = (overtimes: any[] = []) => (
        <div className="flex flex-col">
            {overtimes.map((overtime: any, index: number) => (
                <div key={`${overtime.id || overtime.period}-${index}`} className="flex items-center">
                    {overtime.period == 'after' && <img src='/assetes/svg/moon.svg' className="w-3" />}
                    {overtime.period == 'before' && <img src='/assetes/svg/sun.svg' className="w-3" />}
                    <span className="mr-2">{converDurationToMin(overtime.duration)}</span>
                </div>
            ))}
            {overtimes.length > 1 &&
                <span className="mt-1 text-[10px]">
                    مجموع: {converDurationToMin(overtimes.reduce((sum: number, overtime: any) => sum + Number(overtime.duration || 0), 0))}
                </span>
            }
        </div>
    )

    const exportFull = async () => {
        if (CtxRoll.jsonParmsRollCall?.user?.length != 1) {
            return toast("انتخاب حتما و تنها یک کاربر الزامی میباشد", { type: "error" })
        }
        CtxLoad.setDisplayLoadingBlur(true)
        const res: any = await RollCallFullExport(CtxRoll.jsonParmsRollCall?.user[0])
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.link) {
            Object.assign(document.createElement('a'), {
                target: '_blank',
                rel: 'noopener noreferrer',
                href: res.link,
            }).click();
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }

    const exportFile = async (type: string) => {
        CtxLoad.setDisplayLoadingBlur(true)
        const res: any = await RollCallExport(CtxRoll.jsonParmsRollCall, type)
        CtxLoad.setDisplayLoadingBlur(false)
        var el = document.createElement("a");
        el.setAttribute("href", res);
        el.setAttribute("download", type == 'csv' ? 'export.csv' : 'export');
        el.setAttribute("target", '_blank');
        document.body.appendChild(el);
        el.click();
        el.remove();
    }

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteRoll = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteRollCallApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData(CtxRoll.jsonParmsRollCall)
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }

    const changePage = (type: string) => {
        let data = { ...CtxRoll.jsonParmsRollCall };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        CtxRoll.setJsonParmsRollCall(data)
        getData(data)
    }

    const handelSelectToggle = (e: any, key: string, index: any) => {
        let active = { ...CtxRoll.activeFilterRollCall };
        active[key] = e.target.checked;
        let tableCol = [...col]
        if (e.target.checked) {
            if (key == 'displayDelay') tableCol.splice(5, 0, { title: "تاخیر", index: 1, render: (i: any) => (<>{i.reasons?.length > 0 && converDurationToMin(i?.reasons[0].duration)}</>) },)
            if (key == 'displayWork') tableCol.splice(5, 0, { title: "کارکرد", index: 3, render: (i: any) => (<>{i.duration && i.duration != null && converDurationToMin(i.duration)}</>) },)
            if (key == 'displayOvertime') {
                tableCol.splice(5, 0, {
                    title: "اضافه کاری", index: 2,
                    render: (i: any) => (<>{i.overtimes?.length > 0 && renderOvertimes(i.overtimes)}</>)
                })
            }
        }
        else {
            for (let i in tableCol) {
                if (tableCol[i].index == index) {
                    tableCol.splice(+i, 1)
                }
            }
        }
        setCol(tableCol)
        CtxRoll.setActiveFilterRollCall(active)
    }

    const handelSelectUsers = (userId: any) => {
        let data = { ...CtxRoll.jsonParmsRollCall };
        if (data['user']) {
            if (data['user'].indexOf(userId) == -1) {
                data['user'].push(userId)
            }
            else {
                data['user'].splice(data['user'].indexOf(userId), 1)
            }
        }
        else {
            data['user'] = [userId];
        }
        CtxRoll.setJsonParmsRollCall(data)
    }

    const handelFilterUser = () => {
        setVisibleUser(false)
        getData(CtxRoll.jsonParmsRollCall)
    }

    const handelSelectLocation = (e: any) => {
        let data = { ...CtxRoll.jsonParmsRollCall };
        let active = { ...CtxRoll.activeFilterRollCall };
        if (e.target.value != 'all') {
            data['qr_code_id'] = e.target.value;
            active['location'] = e.target.value;
        }
        else {
            delete data['qr_code_id'];
            active['location'] = -1;
        }
        CtxRoll.setJsonParmsRollCall(data)
        CtxRoll.setActiveFilterRollCall(active)
        getData(data)
    }

    const handelSelectCustomTime = (e: any, type: string) => {
        let data = { ...CtxRoll.jsonParmsRollCall };
        let active = { ...CtxRoll.activeFilterRollCall };
        if (type == 'from') {
            data['from'] = convertStringDateToDateSupport(e?.toDate?.().toString());
            active['startCalender'] = new Date(e?.toDate?.().toString());
        }
        else if (type == 'to') {
            data['to'] = convertStringDateToDateSupport(e?.toDate?.().toString());
            active['endCalender'] = new Date(e?.toDate?.().toString());
        }
        CtxRoll.setJsonParmsRollCall(data)
        CtxRoll.setActiveFilterRollCall(active)
        getData(data)
    }

    const handelSelectPeriod = (value: any) => {
        let data = { ...CtxRoll.jsonParmsRollCall };
        let active = { ...CtxRoll.activeFilterRollCall };
        data['from'] = value[0].from;
        data['to'] = value[0].to;
        active['activePeriod'] = value[1]
        active['startCalender'] = new Date(value[0].from);
        active['endCalender'] = new Date(value[0].to);
        CtxRoll.setJsonParmsRollCall(data)
        CtxRoll.setActiveFilterRollCall(active)
        getData(data)
    }

    const getData = async (parms: any) => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await RollCallApi(parms)
            setTableData(res.data.roll_calls.data)
            setTotal(res.data.totals)
            CtxLoad.setDisplayLoadingSkelton(false)
            setCurrentPage(res.data.roll_calls.current_page)
            setLastPage(res.data.roll_calls.last_page)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "تردد | دایان"
        CtxNav.setActiveMenuItem({ 'item': 1, 'subItem': 0, })
        getData(CtxRoll.jsonParmsRollCall)
        let tableCol = [...col]
        if (CtxRoll.activeFilterRollCall.displayDelay) tableCol.splice(5, 0, { title: "تاخیر", index: 1, render: (i: any) => (<>{i.reasons?.length > 0 && converDurationToMin(i?.reasons[0].duration)}</>) },)
        if (CtxRoll.activeFilterRollCall.displayWork) tableCol.splice(5, 0, { title: "کارکرد", index: 3, render: (i: any) => (<>{i.duration && i.duration != null && converDurationToMin(i.duration)}</>) },)
        if (CtxRoll.activeFilterRollCall.displayOvertime) {
            tableCol.splice(5, 0, {
                title: "اضافه کاری", index: 2,
                render: (i: any) => (<>{i.overtimes?.length > 0 && renderOvertimes(i.overtimes)}</>)
            })
        }
        setCol(tableCol)
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">تردد پرسنل</h1>

            <div className=" w-full flex flex-wrap items-center">
                {CheckPermission(2) &&
                    <>
                        <div className=" w-full md:w-6/12  flex items-center pl-0 md:pl-2 justify-between">
                            <div onClick={() => { setVisibleUser(true) }} className=" w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow px-[10px] text-sm flex justify-center items-center cursor-pointer">
                                <span>{CtxRoll.jsonParmsRollCall?.user.length == 0 && 'انتخاب کارمند'}</span>
                                <span>{CtxRoll.jsonParmsRollCall?.user.length > 0 && `${CtxRoll.jsonParmsRollCall?.user.length} کارمند انتخاب شد`}</span>
                            </div>
                            <div className=" w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                                <CSelect defaultValue={CtxRoll.activeFilterRollCall.location != -1 ? CtxRoll.activeFilterRollCall.location : ""} placeholder={'موقعیت مکانی'} onChange={(e: any) => handelSelectLocation(e)} >
                                    <option value={'all'}>همه</option>
                                    {CtxDash.location?.map((item: any, index: number) =>
                                        <option value={item.id}>{item.name}</option>
                                    )}
                                </CSelect>
                            </div>
                        </div>
                        <div className=" w-full md:w-6/12 mt-2 md:mt-0 flex items-center justify-between">
                            <div className=" w-[32%] sm:min-h-[50px] min-h-[72px] bg-white rounded-md shadow flex sm:flex-row flex-col items-center justify-center sm:justify-between px-1 lg:px-2 py-1 sm:py-0">
                                <span className="text-[10px] sm:mb-0 mb-1 text-center">نمایش تاخیر</span>
                                <CToggle onChange={(e: any) => handelSelectToggle(e, 'displayDelay', 1)} checked={CtxRoll.activeFilterRollCall.displayDelay} />
                            </div>
                            <div className=" w-[32%] sm:min-h-[50px] min-h-[72px] bg-white rounded-md shadow flex sm:flex-row flex-col items-center justify-center sm:justify-between px-1 lg:px-2 py-1 sm:py-0">
                                <span className="text-[10px] sm:mb-0 mb-1 text-center">نمایش اضافه کاری </span>
                                <CToggle onChange={(e: any) => handelSelectToggle(e, 'displayOvertime', 2)} checked={CtxRoll.activeFilterRollCall.displayOvertime} />
                            </div>
                            <div className=" w-[32%] sm:min-h-[50px] min-h-[72px] bg-white rounded-md shadow flex sm:flex-row flex-col items-center justify-center sm:justify-between px-1 lg:px-2 py-1 sm:py-0">
                                <span className="text-[10px] sm:mb-0 mb-1 text-center">نمایش کارکرد</span>
                                <CToggle onChange={(e: any) => handelSelectToggle(e, 'displayWork', 3)} checked={CtxRoll.activeFilterRollCall.displayWork} />
                            </div>
                        </div>
                    </>
                }
            </div>

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <div className="w-full md:w-fit flex items-center">
                    {CheckPermission(2) &&
                        <>
                            <div className=" hidden md:flex items-center pl-2">
                                <div className="relative group">
                                    {CtxRoll.jsonParmsRollCall?.user.length != 1 &&
                                        <div className="bg-dayan-gray-200 w-[180px] h-[30px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-35px] group-hover:opacity-100 group-hover:visible transition-all ">برای فعال شدن حتما و تنها یک کاربر انتخاب نمایید</div>
                                    }
                                    <div onClick={exportFull} className={` w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex flex-col justify-center items-center text-[11px] ${CtxRoll.jsonParmsRollCall?.user?.length != 1 ? 'cursor-not-allowed text-gray-400' : 'cursor-pointer text-white'}`}>
                                        <span>گزارش</span>
                                        <span className="mt-1">کامل</span>
                                    </div>
                                </div>
                                <div onClick={() => exportFile('csv')} className=" w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex justify-center items-center cursor-pointer mr-2">
                                    <svg x="0px" y="0px" viewBox="0 0 548.29 548.291" className={`  h-7 fill-white `}>
                                        <use xlinkHref="/assetes/svg/csv.svg#csv" />
                                    </svg>
                                </div>
                                <div onClick={() => exportFile('excel')} className=" w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex justify-center items-center cursor-pointer mr-2">
                                    <svg x="0px" y="0px" viewBox="0 0 26 26" className={`  h-7 fill-green-800 `}>
                                        <use xlinkHref="/assetes/svg/excel.svg#excel" />
                                    </svg>
                                </div>
                            </div>
                            <div className=" w-full md:w-[240px] flex flex-col">
                                <ReportSelectPeriod onChange={(value: any) => handelSelectPeriod(value)} activeTab={CtxRoll.activeFilterRollCall.activePeriod} />
                                <div className=" w-full flex   mt-2">
                                    <div className="jalali-datePicker w-full h-[30px] ml-1 bg-white rounded-lg shadow flex justify-center items-center text-[11px]  relative group">
                                        <div className="bg-dayan-gray-200 w-fit h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">تاریخ شروع</div>
                                        <DatePicker calendar={persian} locale={persian_fa} value={CtxRoll.activeFilterRollCall?.startCalender} onChange={(e: any) => { handelSelectCustomTime(e, 'from') }} />
                                    </div>
                                    <div className="jalali-datePicker w-full h-[30px] mr-1 bg-white rounded-lg shadow flex justify-center items-center text-[11px] relative group">
                                        <div className="bg-dayan-gray-200 w-fit h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">تاریخ پایان</div>
                                        <DatePicker calendar={persian} locale={persian_fa} value={CtxRoll.activeFilterRollCall?.endCalender} onChange={(e: any) => { handelSelectCustomTime(e, 'to') }} />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                    {CheckPermission(2) &&
                        <>
                            <button onClick={exportFull} className={`w-full md:w-[120px] h-[30px] md:h-[40px] md:hidden flex bg-dayan-gray-200 rounded-md text-sm justify-center items-center text-center text-[11px] ${CtxRoll.jsonParmsRollCall?.user?.length != 1 ? 'cursor-not-allowed text-gray-400' : 'cursor-pointer text-white'} `}>گزارش کامل</button>
                            <button onClick={() => exportFile('csv')} className="w-full md:w-[120px] h-[30px] md:h-[40px] mx-1 md:hidden flex bg-dayan-gray-200 rounded-md text-sm text-white justify-center items-center text-center text-[11px]">CSV</button>
                            <button onClick={() => exportFile('excel')} className="w-full md:w-[120px] h-[30px] md:h-[40px] mx-1 md:hidden flex bg-dayan-gray-200 rounded-md text-sm text-white justify-center items-center text-center text-[11px]">اکسل</button>
                        </>
                    }

                    {CheckPermission(3) ?
                        <button className=" w-full md:w-[120px] h-[30px] md:h-[40px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                            <Link to='/p/reports/rollcall/add' className=" w-full h-full flex justify-center items-center">
                                + افزودن تردد
                            </Link>
                        </button>
                        :
                        <div />
                    }
                </div>
            </div>

            {CheckPermission(4) &&
                <div className=" w-full mt-[20px]">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} >
                            <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
                        </TablePage>
                        :
                        <CSkeletonTable />
                    }
                </div>
            }

            {CheckPermission(4) &&
                <>
                    {total != null && tableData?.length > 0 &&
                        <div className=" w-full my-[40px] px-3 flex flex-col rounded-lg overflow-hidden table-report-shadow bg-[#f8f8f8]">
                            <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end border-b text-[12px]">
                                مجموع کارکرد در شیفت : {converDurationToMin(total.all)}
                            </div>
                            <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end text-[12px]">
                                مجموع کارکرد(کارکرد در شیفت+ اضافه کاری‌های تایید شده):  {converDurationToMin(total.all_plus_approved_overtimes)}
                            </div>
                        </div>
                    }
                </>
            }

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteRoll} loading={CtxLoad.displayLoadingBtn} />

            <ModalFilterUser visible={visibleUser} setVisible={setVisibleUser} onOk={handelFilterUser} listUser={CtxDash.employees} listSelected={CtxRoll.jsonParmsRollCall?.user} selectUser={handelSelectUsers} />

        </div>
    )
}